import { render, staticRenderFns } from "./DatosPersonales.vue?vue&type=template&id=45a8d14b&scoped=true&"
import script from "./DatosPersonales.vue?vue&type=script&lang=js&"
export * from "./DatosPersonales.vue?vue&type=script&lang=js&"
import style0 from "./DatosPersonales.vue?vue&type=style&index=0&id=45a8d14b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a8d14b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSelect,VSnackbar,VTextField})
